import { CustomElement, resolve } from 'aurelia';
import { ConfigAdminService } from '../../services';
import template from './config-admin-panel.html';
import './config-admin-panel.css';

// Admin-only modal that lists every effective configuration parameter the app has loaded, with
// secret values redacted server-side. Opened from the admin menu; all state and the load call live
// in ConfigAdminService. Read-only: an audit view, not an editor.
export class ConfigAdminPanelElement {
  readonly config: ConfigAdminService = resolve(ConfigAdminService);
}

export const ConfigAdminPanel = CustomElement.define({
  name: 'config-admin-panel',
  template
}, ConfigAdminPanelElement);
